// @ts-nocheck

import React from 'react';
import { navigate } from '../../lib/routerAdapter';
import { tripInspectionFrequencyApi } from './../../lib/api';
import CommonListPage from './../../components/hoc/common/handbook/ListPage';
import Page from '../../components/hoc/common/handbook/PageContext';
import { withUserAccess } from './../withUserAccess';

import { Filter } from './components';
import { formatDateTimeToString } from '../../lib/helpers';
import { vehicleTypes } from '../../lib/enum';
import { getBreadCrumbsByUrl } from '../../lib/autoBreadcrumbs';

const entryPointPath = '/admin/trip-inspection-frequency/';

const columns = [
{
  title: 'Тип ТС',
  dataIndex: 'vehicleType',
  render: (vehicleType) => {
    return vehicleTypes[vehicleType];
  }
},
{
  title: 'Количество осмотров в рабочий день',
  dataIndex: 'inspectionCount'
},
{
  title: 'Дата начала',
  dataIndex: 'startDate',
  render: (startDate) =>
  formatDateTimeToString(startDate, 'DD.MM.YYYY')
},
{
  title: 'Дата окончания',
  dataIndex: 'endDate',
  render: (endDate) => formatDateTimeToString(endDate, 'DD.MM.YYYY')
}];


const breadCrumbs = getBreadCrumbsByUrl(entryPointPath);

const access = {
  add: () => navigate(`${entryPointPath}new`)
};

export default withUserAccess(({ userAccess }) => {
  return (
    <Page>
      <CommonListPage
        crud={tripInspectionFrequencyApi}
        pageHeaderProps={{
          breadCrumbs,
          mainHeader:
          'Периодичность проведения предрейсовых/послерейсовых осмотров',
          access
        }}
        tableListProps={{
          columns,
          onSelect: (id) => navigate(`${entryPointPath}${id}`),
          canDelete: true
        }}
        filter={Filter} />

    </Page>);

});